import React, { useContext, useEffect, useState } from "react";
import "./New_In_Store.css";
import { useNavigate } from "react-router-dom";
import New_Lottie from "../../Animation/new_lottie/New_Lottie";
import Common_Heading_Holder from "../../Common-Component/common_heading_holder/Common_Heading_Holder";
import Store_Product_Card from "./store_product_card/Store_Product_Card";
import { NewInStore } from "../../../utils/apis/Product/Product";
import { Context } from "../../../utils/context";

const New_In_Store = () => {
  const { IMG_URL, shimmerLoader, setShimmerLoader, currentLocation } =
    useContext(Context);

  const [newinstore, setNewinstore] = useState([]);
  const navigate = useNavigate();

  const getNewInStore = async () => {
    setShimmerLoader(true);
    const city =
      currentLocation?.city ||
      currentLocation?.formatted_address ||
      currentLocation?.address_components?.[0]?.long_name ||
      "";
    const res = await NewInStore("", city);
    if (res?.success) {
      setNewinstore(res?.data);
      setShimmerLoader(false);
    }
  };

  useEffect(() => {
    getNewInStore();
  }, [currentLocation]);

  return (
    <section className="New_In_Store">
      {newinstore?.length > 0 && (
        <>
          {" "}
          <div className="new_lottie_div">
            <New_Lottie />
          </div>
          <Common_Heading_Holder
            headingText={"New in Store"}
            viewShowAllButton
            goto="/shop"
          />
          <div className="main_content_div">
            <div className="desktop_view">
              <div className="row justify-content-center">
                <div className="col-xl-5 col-lg-6 col-md-5 col-sm-7">
                  <div className="main_img_div">
                    {newinstore.length > 0 && (
                      <Store_Product_Card
                        img={IMG_URL + newinstore[0]?.image1}
                        name={newinstore[0]?.name}
                        discount={newinstore[0]?.discount}
                        id={newinstore[0]?.id}
                      />
                    )}
                  </div>
                </div>

                <div className="col-xl-7 col-lg-12 col-md-7">
                  <div className="grid_view_div">
                    {newinstore.slice(1).map((item) => {
                      return (
                        <Store_Product_Card
                          img={IMG_URL + item.image1}
                          name={item?.name}
                          discount={item?.discount}
                          id={item?.id}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            <div className="mobile_view">
              <div className="row justify-content-center">
                <div className="col-xl-7 col-lg-12 col-md-7">
                  <div className="grid_view_div">
                    {newinstore?.map((item) => {
                      return (
                        <Store_Product_Card
                          img={IMG_URL + item.image1}
                          name={item?.name}
                          discount={item?.discount}
                          id={item?.id}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default New_In_Store;
